// src/classes/ReservationGuest.js
export default class ReservationGuest {
    constructor(profileId, isPrimary) {
        this.profileInfo = {
            profileIdList: [
                {
                    type: "Profile",
                    id: profileId
                }
            ]
        };
        this.primary = isPrimary;
    }
}
